import PadraoModel from 'src/core/model/PadraoModel.js'

export default class WebmotorsCambioModel extends PadraoModel {
  recurso = 'webmotors/cambios';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Cãmbios Webmotors';

  colunasGrid = [
  ];

  form = {
    CodigoCambio: null,
    Descricao: null
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
